import { Component, OnInit } from '@angular/core';
import { PersonalizationsService } from '../base/services/personalizations/personalizations.service';
import { Environment } from '../models/environment';

@Component({
  selector: 'app-footer-noauth',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  customFooter: boolean = false;

  customLinks: string[] = [];

  environment: Environment;

  constructor(private _personalization: PersonalizationsService) {
    this.environment = this._personalization.sendEnv;
   }

  ngOnInit(): void {
    this.customLinks = this.environment?.features.footerLinks?.customInfo;

    this.customFooter = this.environment?.features.footerLinks?.active ? true : false;
  }

}
